// extracted by mini-css-extract-plugin
export default {"subheader":"SubheaderComponent_subheader__Q5FFS"};